import { Pipe, PipeTransform } from "@angular/core";
import { SystemService } from '../services/system.service';

@Pipe(
    {
        name: 'filter',
        pure: true
    })

export class FilterPipe implements PipeTransform {
    constructor(public systemService: SystemService) {
    }

    transform(items: any, query: any, queryArgs: Array<any>) {
        if (!items || query === '' || query == null || query == undefined) {
            return items;
        }

        let isText = typeof query === 'string';


        if (isText) {
            query = this.systemService.removeAccents(query.toLowerCase());
        }

        let queryCleared = isText ? query.replace(/[^a-zA-z0-9ñÑ\s]/ig, '').replace(/(\[*)(\^*)(\]*)(\\*)/g, '').replace(/\s+$/, '') : null;

        let attributes: Array<any> = [];

        queryArgs.forEach((p: any) => {
            attributes.push(p.split('.'));
        })


        return items.filter((item: any) => {

            for (let indexI = 0; indexI < attributes.length; indexI++) {

                let itemaux = item[attributes[indexI][0]];

                for (let indexK = 1; indexK < attributes[indexI].length; indexK++) {
                    itemaux = itemaux[attributes[indexI][indexK]];
                }

                if (!itemaux) {
                    return false;
                }

                if (isText) {
                    let text = this.systemService.removeAccents(itemaux.toLowerCase());
                    text = text.replace(/[^a-zA-z0-9ñÑ\s]/g, "");

                    let regex = new RegExp("^" + query + "|\\s" + query);
                    let index = text.match(regex);

                    if (index === null) {
                        let lastIndex = text.lastIndexOf(queryCleared);

                        if (lastIndex >= 0 && ((lastIndex + queryCleared.length) == text.length) && (lastIndex == 0 || text[lastIndex - 1] == " ")) {
                            return true;
                        }
                        {
                            continue;
                        }
                    }
                    else {
                        return true;
                    }
                }
                else if (itemaux == query) {
                    return true;
                }
                else {
                    continue;
                }


            }

            return false;
        });
    }
}
